import store from '@/store'

import { createLeafletCreationStore } from './createLeafletCreationStore'
import { createCreationApi } from './creationApi'
import type { CreationContext } from './creationTask'
import { createTaskPersistence } from './taskPersistence'

let instance: ReturnType<typeof createLeafletCreationStore> | undefined

export function currentCreationContext(): CreationContext | null {
  const { name, profile, token } = store.getters
  return name && profile && token ? { account: name, country: profile } : null
}

export function useLeafletCreationStore() {
  if (!instance) {
    instance = createLeafletCreationStore({
      api: createCreationApi(),
      persistence: createTaskPersistence(localStorage),
      locks: navigator.locks
    })
  }
  return instance
}
